module.exports = __webpack_public_path__ + "img/Menu-09.7f112562.webp";